import React from 'react'
import {useSelector} from 'react-redux'
import { DataGrid } from '@mui/x-data-grid';

function SolicitudDetalle() {

    const solicitud = useSelector(store => store.Solicitudes.detalle)
    const rows = []
    const columns = [
        { field: 'id', headerName: 'Columna', width: 250 },
        { field: 'valor', headerName: 'Valor', width: 220}
    ]

    for(const prop in solicitud) {
        rows.push({id : `${prop}`, valor: solicitud[prop]===true?("Si"):solicitud[prop]===false?("No"):(solicitud[prop])})
    }

    return (
        <div className='container mt-1 ms-1'>
            <div style={{ height: 700, width: '100%' }}>
                <DataGrid
                    rows={rows}
                    columns={columns}
                    pageSize={20}
                    rowsPerPageOptions={[20]}
                />
            </div>
        </div>
    )
}

export default SolicitudDetalle
